/* eslint-disable import/first */

import _ from 'underscore';
import { locationTargetsOptionKeys } from '@bingads-webui-campaign-react/wizard-shared-components';
import {
  fillAdditionalInfoToBundleLocationCriterions,
  convertIntentOption,
  compareAndProcessLocations,
  getLocationHash,
} from '../..';

const setParentForCampaign = (targets, campaign) => targets.map((criterion) => {
  if (campaign.Id) {
    return {
      ...criterion,
      Campaign: {
        Id: campaign.Id,
      },
    };
  }
  return {
    ...criterion,
    CampaignName: campaign.name.value,
  };
});

const setParentForAdGroup = (targets, adGroup, campaign) => targets.map((criterion) => {
  if (adGroup.Id) {
    return {
      ...criterion,
      AdGroup: {
        Id: adGroup.Id,
      },
    };
  }
  return {
    ...criterion,
    CampaignName: campaign.Name,
    AdGroupName: adGroup.name.value,
  };
});

export const convertLocationStateToLocationSchemaCampaign = (location, bundleLocationCriterions, campaign, adGroup, contactIntent = true) => {
  const {
    currentLocations,
    targetOption,
  } = location.currentLevelSettings;
  let {
    initLocations = [],
  } = location.currentLevelSettings;

  const isTargetEverywhere = targetOption === locationTargetsOptionKeys.everywhere || location.useParentLevel === true;
  let finalLocations = [];
  const intent = {
    Id: location.currentLevelSettings.intentId,
    CriterionType: 'LocationIntentCriterion',
    Criterion: {
      Type: 'LocationIntentCriterion',
      LocationIntentCriterion: {
        IntentOption: convertIntentOption(location.currentLevelSettings),
      },
    },
  };

  if (isTargetEverywhere) {
    finalLocations = [];
  } else if (targetOption === locationTargetsOptionKeys.bundleOrDefaultMarket) {
    if (location.bidMode === true) {
      finalLocations = currentLocations;
    } else {
      finalLocations = fillAdditionalInfoToBundleLocationCriterions(currentLocations, bundleLocationCriterions);
    }
  } else if (targetOption === locationTargetsOptionKeys.specific) {
    if (campaign.bidStrategy.option === 'Commission') {
      // filter out new added included locations
      finalLocations = currentLocations.filter(x => !(x.SelectionStatus === 'Included'));
      const includedInitLocations = initLocations.filter(x => x.SelectionStatus === 'Included' && x.Criterion.Type !== 'Radius');
      const excludedInitLocations = initLocations.filter(x => x.SelectionStatus === 'Excluded');
      const finalHashDict = _.object(_.map(finalLocations, lt => [getLocationHash(lt), lt]));
      const finalExcludedLocationIds = finalLocations.map(x => x.Criterion.LocationCriterion.LocationId);
      // delete the conflicted locations
      const conflictedLocations = includedInitLocations.filter((x) => {
        if (_.has(finalHashDict, getLocationHash(x))) {
          return true;
        }
        if (!_.isEmpty(_.intersection(x.Criterion.LocationCriterion.EnclosingLocationIds, finalExcludedLocationIds))) {
          return true;
        }
        return false;
      });
      initLocations = conflictedLocations.concat(excludedInitLocations);
    } else {
      finalLocations = currentLocations;
    }
  }

  finalLocations = compareAndProcessLocations(initLocations, finalLocations);

  if (campaign.bidStrategy.option !== 'Commission' && contactIntent) {
    finalLocations = finalLocations.concat([intent]);
  }

  finalLocations = adGroup ? setParentForAdGroup(finalLocations, adGroup, campaign) : setParentForCampaign(finalLocations, campaign);

  return finalLocations;
};
